import axios from "axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialsList = async ({ page, pageSize, search, environment }) => {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("page_size", pageSize);
  if (search) params.append("search", search);
  if (environment && environment !== "all") params.append("environment", environment);

  const res = await axios.get(`${__API_URL__}/api/photos/trials_list_view`, {
    params,
    headers: { Authorization: `Token ${token}` },
  });
  return res.data;
};

const useGetTrialsList = ({ page = 1, pageSize = 10, search = "", environment = "all" }) => {
  return useQuery({
    queryKey: ["trials_list", page, pageSize, search, environment],
    queryFn: () => fetchTrialsList({ page, pageSize, search, environment }),
    placeholderData: keepPreviousData,
    refetchOnMount: true,
  });
};

export default useGetTrialsList;
